"use strict";
(self["webpackChunkmijn_tokens_browser_asn"] = self["webpackChunkmijn_tokens_browser_asn"] || []).push([[284],{

/***/ 3991:
/***/ ((module) => {

module.exports = /*#__PURE__*/JSON.parse('{"mijn.tokens.browser.title":{"default":"Browser aanmelden"},"mijn.tokens.browser.login.link":{"default":"/inloggen/#/?token=reset","asn":"/online/web/onlinebankieren/inloggen/#/?token=reset","blg":"/online/web/mijnblg/inloggen/#/?token=reset","reb":"/online/web/mijnregiobank/inloggen/#/?token=reset","sns":"/online/web/mijnsns/inloggen/#/?token=reset"},"mijn.tokens.browser.msie.link":{"default":"/particulier/service/browsers-en-besturingssystemen.html","asn":"/online-en-mobiel-bankieren/veilig-bankieren/beveilig-computer-tablet-en-mobiel.html","blg":"/browsers-en-systemen.html","reb":"/service/algemeen/browsers-en-besturingssystemen.html","sns":"/particulier/service/browsers-en-besturingssystemen.html"},"mijn.tokens.browser.notificationText":{"default":"Je bent uitgelogd! Je kunt nu je browser aanmelden."}}');

/***/ }),

/***/ 4885:
/***/ ((module) => {

module.exports = /*#__PURE__*/JSON.parse('{"mijn.tokens.browser.identify":{"default":"/online/browser-registratie"}}');

/***/ }),

/***/ 7748:
/***/ ((module) => {

module.exports = /*#__PURE__*/JSON.parse('{"mijn-tokens-browser.logout-modal.url":{"default":"about:blank","asn":"/online/web/onlinebankieren/","blg":"/online/web/mijnblg/","reb":"/online/web/mijnregiobank/","sns":"/online/web/mijnsns/"}}');

/***/ }),

/***/ 7947:
/***/ ((module) => {

module.exports = /*#__PURE__*/JSON.parse('{"mijn.tokens.browser.start.url.back":{"default":"/inloggen/","asn":"/online/web/onlinebankieren/inloggen/","blg":"/online/web/mijnblg/inloggen/","reb":"/online/web/mijnregiobank/inloggen/","sns":"/online/web/mijnsns/inloggen/"}}');

/***/ }),

/***/ 8069:
/***/ ((module) => {

module.exports = /*#__PURE__*/JSON.parse('{"mijn.tokens.browser.finished.login.url":{"default":"/mijn-login/","asn":"/online/web/onlinebankieren/inloggen/#/?token=browser","blg":"/online/web/mijnblg/inloggen/#/?token=browser","reb":"/online/web/mijnregiobank/inloggen/#/?token=browser","sns":"/online/web/mijnsns/inloggen/#/?token=browser"}}');

/***/ })

}]);